module.exports = __webpack_public_path__ + "static/media/5-Y.551b36a8.mp3";